import { FC } from 'react';
import { Alert } from 'melp-design/components';
import { VisibilityOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useMe } from 'state/Administrators';

export const CompanyScopeInfoMessage: FC = () => {
  const { t } = useTranslation();
  const { me, isFeatureEnabled } = useMe();

  if (
    !me ||
    me.companyScopeEmployeesCount === null ||
    !isFeatureEnabled('advancedPermissions')
  )
    return null;

  return (
    <Alert
      severity="info"
      icon={VisibilityOutlined}
      title={t('employees.companyScope.info.title', {
        visibleCount: me.companyScopeEmployeesCount,
        totalCount: me.activeEmployeesCount,
      })}
    >
      {t('employees.companyScope.info.message')}
    </Alert>
  );
};
